export let highPriorityGroupLabel = "RyuRl";
export let lowPriorityGroupLabel = "bIuHwb";
export let normalPriorityGroupLabel = "URmbIe";
export default {highPriorityGroupLabel,lowPriorityGroupLabel,normalPriorityGroupLabel};